// extracted by mini-css-extract-plugin
export var active = "_ho-2";
export var recordingDot = "_ho-1";
export var recordingIndicator = "_ho-0";